import { render, staticRenderFns } from "./editClonedShifts.vue?vue&type=template&id=0faaf0a8&"
import script from "./editClonedShifts.vue?vue&type=script&lang=js&"
export * from "./editClonedShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports